import {
  GET_USER_FOUND,
  GET_USER_NOT_FOUND,
  GET_USER_REQUEST,
  LOGOUT_SUCCESS,
} from '../Actions/AuthAction';

interface IAuthState {
  loading: boolean,
  user: any,
  token: string,
  role: Array<String>
  cjsc_id:boolean,
  cjsc_id_ip:boolean,
  cjsc_ip_without_id:boolean,
  cjsc_ip:boolean,
  cjscIds:any,
  cjsc_script:boolean,
  cjsc_fifo:boolean,
  cjsc_multi_ipnoid:boolean,
  cjsc_multi_ipid:boolean,
  cjsc_infinite_fifo: boolean,
  cjsc_ignoreHttp:boolean,
  show_cjsc_ignoreHttp:boolean,
  subUsers:any,
  panda:boolean,
  monitor:boolean,
  cjsc_user_agent:boolean,
  concat:boolean,
  controlium_type:boolean,
  tenant_name:any,
  show_hash:boolean,
  logo_folder:any,
  line_item_id:any,
  line_item_id_demo:any,
  line_item_without_id:any,
  line_item_without_id_demo:any,
  countries:any,
  countries_type:any,
  browsers:any,
  browsers_type:any,
  oss:any,
  oss_type:any,
  ccu_campaigns:any,
  truncated_ips:boolean,
  multi_campaign:boolean,
  allow_pause:boolean,
  allow_edit:boolean,
  audience_idfa:boolean,
  audience_ad_id:boolean,
  audience_ip_address:boolean,
  audience_web_id:boolean,
  disrupt_opsec_v2:boolean,
  id:any,
  eyield:boolean,
  tyield:boolean,
  sync_user:boolean,
  sync_domain:boolean,
  ah_user:boolean,
  cc_infinite_fifo:boolean,
}

const LoginInitialState: IAuthState = {
  loading: false,
  user: {},
  token: '',
  role: [],
  cjsc_id:false,
  cjsc_ip:false,
  cjscIds:'',
  cjsc_script:false,
  cjsc_fifo:false,
  cjsc_multi_ipnoid:false,
  cjsc_multi_ipid:false,
  cjsc_infinite_fifo:false,
  subUsers:'',
  cjsc_id_ip:false,
  cjsc_ip_without_id:false,
  cjsc_ignoreHttp:false,
  show_cjsc_ignoreHttp:false,
  panda:false,
  monitor:false,
  cjsc_user_agent:false,
  concat:false,
  controlium_type:false,
  tenant_name:'',
  show_hash:true,
  logo_folder:'',
  line_item_id:'',
  line_item_id_demo:'',
  line_item_without_id:'',
  line_item_without_id_demo:'',
  countries:[],
  countries_type:'',
  browsers:[],
  browsers_type:'',
  oss:[],
  oss_type:'',
  ccu_campaigns:[],
  truncated_ips:false,
  multi_campaign:false,
  allow_pause:false,
  allow_edit:false,
  audience_idfa:false,
  audience_ad_id:false,
  audience_ip_address:false,
  audience_web_id:false,
  disrupt_opsec_v2:false,
  id:'',
  eyield:false,
  tyield:false,
  sync_user:false,
  sync_domain:false,
  ah_user:false,
  cc_infinite_fifo:false,
};

export const AuthReducer = (state: IAuthState = LoginInitialState, action: any) => {
  switch (action.type) {
    case GET_USER_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_USER_FOUND:
      return {
        ...state,
        user: action.payload,
        loading: false,
        id:action.id,
        role: action.userRole,
        cjsc_ip:action.cjsc_ip,
        cjsc_id:action.cjsc_id,
        cjscIds:action.cjscIds,
        cjsc_script:action.cjsc_script,
        cjsc_fifo:action.cjsc_fifo,
        cjsc_multi_ipnoid:action.cjsc_multi_ipnoid,
        cjsc_multi_ipid:action.cjsc_multi_ipid,
        cjsc_infinite_fifo:action.cjsc_infinite_fifo,
        cjsc_ignoreHttp:action.cjsc_ignoreHttp,
        show_cjsc_ignoreHttp:action.show_cjsc_ignoreHttp,
        subUsers:action.subUsers,
        cjsc_id_ip:action.cjsc_id_ip,
        cjsc_ip_without_id:action.cjsc_ip_without_id,
        panda:action.panda,
        monitor:action.monitor,
        cjsc_user_agent:action.cjsc_user_agent,
        concat:action.concat,
        controlium_type:action.controlium_type,
        tenant_name:action.tenant_name,
        show_hash: action.show_hash,
        logo_folder:action.logo_folder,
        line_item_id:action.line_item_id,
        line_item_id_demo:action.line_item_id_demo,
        line_item_without_id:action.line_item_without_id,
        line_item_without_id_demo:action.line_item_without_id_demo,
        countries:action.countries,
        countries_type:action.countries_type,
        browsers:action.browsers,
        browsers_type:action.browsers_type,
        oss:action.oss,
        oss_type:action.oss_type,
        ccu_campaigns:action.ccu_campaigns,
        truncated_ips:action.truncated_ips,
        multi_campaign:action.multi_campaign,
        allow_pause:action.allow_pause,
        allow_edit:action.allow_edit,
        audience_idfa:action.audience_idfa,
        audience_ad_id:action.audience_ad_id,
        audience_ip_address:action.audience_ip_address,
        audience_web_id:action.audience_web_id,
        disrupt_opsec_v2:action.disrupt_opsec_v2,
        eyield:action.eyield,
        tyield:action.tyield,
        sync_user:action.sync_user,
        sync_domain:action.sync_domain,
        ah_user:action.ah_user,
        cc_infinite_fifo:action.cc_infinite_fifo,
      };

    case GET_USER_NOT_FOUND:
      return { ...LoginInitialState };

    case LOGOUT_SUCCESS:
      localStorage.removeItem('token');
      return {
        ...state,
        user: {},
      };

    default:
      return state;
  }
};
